import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as Trend } from "../../assets/svg/trend-up-fill.svg";
import { ReactComponent as Settings } from "../../assets/svg/mdi_settings-outline.svg";
import { ReactComponent as User } from "../../assets/svg/solar_user-outline.svg";
// import { ReactComponent as Cloud } from "../../assets/svg/pepicons-pencil_cloud-up.svg";
// import { ReactComponent as Channel } from "../../assets/svg/uil_channel.svg";
import { ReactComponent as Security } from "../../assets/svg/carbon_security.svg";
import { ReactComponent as Lifecycle } from "../../assets/svg/carbon_ai-governance-lifecycle.svg";

const services = [
  {
    icon: <Trend />,
    title: "Business Productivity Solution",
    desc: "To boost business organizations' productivity, Outcess takes an enterprise-wide approach to build an empowered...",
    link: "business-productivity-solutions"
  },
  {
    icon: <Settings />,
    title: "Business Process Outsourcing",
    desc: "Business process outsourcing relieves you of the burden of trying to manage non-core business processes...",
    link: "business-process-outsourcing"
  },
  {
    icon: <User />,
    title: "AI Powered Customer Engagement Solutions",
    desc: "Customer Engagement Services offer an integrated set of digital solutions to help organizations create engaging customer",
    link: "customer-engagement-Solutions"
  },
  // {
  //   icon: <Cloud />,
  //   title: "Cloud Solutions",
  //   desc: "Outcess is well versed in deploying a variety of critical cloud services platforms, including hybrid clouds...",
  // },
  // {
  //   icon: <Channel />,
  //   title: "Omni Channel Marketing",
  //   desc: "SmartMessage provides an enterprise-ready, GDPR-compliant omni-channel communication platform...",
  // },
  {
    icon: <Security />,
    title: "AML Solutions",
    desc: "To boost business organizations' productivity, Outcess takes an enterprise-wide approach to build an empowered...",
    link: "aml-solutions"
  },
  {
    icon: <Lifecycle />,
    title: "AI Governance Lifecycle",
    desc: "Helps organizations implement responsible AI with a full lifecycle governance approach...",
    link: "clm-solutions"
  },
];

const ServicesWeDeliver = () => {
  const containerWrapperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Auto scroll effect
  useEffect(() => {
    if (isPaused) return; // Skip if paused

    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused]); // Re-run effect when isPaused changes

  // Scroll to card when index changes
  useEffect(() => {
    const container = containerWrapperRef.current;
    if (container) {
      const cardWidth = container.scrollWidth / services.length;
      container.scrollTo({
        left: cardWidth * activeIndex,
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  const handleIndicatorClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div
      className="services-we-deliver_container_indicator"
      onMouseEnter={() => setIsPaused(true)} // Pause on hover
      onMouseLeave={() => setIsPaused(false)} // Resume on leave
    >
      <div
        ref={containerWrapperRef}
        style={{
          overflow: "hidden",
          scrollBehavior: "smooth",
          width: "100%",
        }}>
        <div className="services-we-deliver_container">
          {services.map((service, index) => (
            <div
              className="services-we-deliver"
              key={index}
              style={{ flex: "0 0 auto", minWidth: "300px" }}>
              <div className="services-we-deliver_top">
                {service.icon}
                <h3 className="business_productivity_text">{service.title}</h3>
                <p className="business_productivity_text_sub">{service.desc}</p>
              </div>
              <div className="services-we-deliver_bottom">
              <NavLink to={`/${service.link}`} exact>
                <p className="services-we-deliver_learn_more">Learn More</p>
              </NavLink>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="services_we_deliver_condication">
        {services.map((_, i) => (
          <span
            key={i}
            className={
              i === activeIndex
                ? "deliver_indication_active"
                : "deliver_indication"
            }
            onClick={() => handleIndicatorClick(i)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicesWeDeliver;
